import { AUTH_TOKEN } from "../constants/constants";
import { WEBSOCKET_URL } from "../constants/env";

export const ACTION_SUBSCRIBE_EXPORT_UPDATE = "subscribe_export_update";
export const ACTION_SUBSCRIBE_SHOT_UPDATE = "subscribe_shot_update";
export const ACTION_SUBSCRIBE_ANNOTATION_UPDATE = "subscribe_annotation_update";
export const ACTION_SUBSCRIBE_INFERENCE_UPDATE =
  "subscribe_infrence_cutout_update";
export const ACTION_SUBSCRIBE_CUTOUT_UPDATE = "subscribe_cutout_update";
export const ACTION_SUBSCRIBE_NOTIFICATION_UPDATE =
  "subscribe_notification_events";
export const ACTION_SUBSCRIBE_SUBSCRIPTION_UPDATE =
  "subscribe_subscription_update";

const connectionPool = new Map<string, WebSocket>();
const connectionRefs = new Map<string, number>();

const cleanupConnection = (connectionKey: string) => {
  const socket = connectionPool.get(connectionKey);
  if (socket) {
    socket.onopen = null;
    socket.onmessage = null;
    socket.onerror = null;
    socket.onclose = null;
  }
  connectionPool.delete(connectionKey);
  connectionRefs.delete(connectionKey);
};

const makeId = () => {
  let result = "";
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  for (let i = 0; i < 12; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const getRequestData = (action: string, data?: unknown) => {
  return JSON.stringify({
    action,
    request_id: makeId(),
    data,
  });
};

export const getSocket = (path: string) => {
  const token = localStorage.getItem(AUTH_TOKEN);
  if (!token) {
    return null;
  }

  const connectionKey = `${path}:${token}`;

  if (connectionPool.has(connectionKey)) {
    const existingSocket = connectionPool.get(connectionKey);
    if (
      existingSocket &&
      (existingSocket.readyState === WebSocket.OPEN ||
        existingSocket.readyState === WebSocket.CONNECTING)
    ) {
      connectionRefs.set(
        connectionKey,
        (connectionRefs.get(connectionKey) || 0) + 1,
      );
      return existingSocket;
    }

    connectionPool.delete(connectionKey);
    connectionRefs.delete(connectionKey);
  }

  const socket = new WebSocket(`${WEBSOCKET_URL}/${path}?token=${token}`);
  socket.onerror = (event) => {
    console.log("Error", event);
    cleanupConnection(connectionKey);
  };

  socket.onclose = (event) => {
    cleanupConnection(connectionKey);
  };

  connectionPool.set(connectionKey, socket);
  connectionRefs.set(connectionKey, 1);

  return socket;
};

export const closeSocket = (path: string) => {
  const token = localStorage.getItem(AUTH_TOKEN);
  if (!token) return;

  const connectionKey = `${path}:${token}`;

  if (connectionPool.has(connectionKey)) {
    const refCount = (connectionRefs.get(connectionKey) || 1) - 1;
    connectionRefs.set(connectionKey, refCount);

    if (refCount <= 0) {
      const socket = connectionPool.get(connectionKey);
      if (
        socket &&
        (socket.readyState === WebSocket.OPEN ||
          socket.readyState === WebSocket.CONNECTING)
      ) {
        socket.close(1000, "Component unmounted");
      }
      cleanupConnection(connectionKey);
    }
  }
};

export const cleanupAllSockets = () => {
  connectionPool.forEach((socket, key) => {
    if (
      socket.readyState === WebSocket.OPEN ||
      socket.readyState === WebSocket.CONNECTING
    ) {
      socket.close(1000, "Page unload");
    }
    cleanupConnection(key);
  });
};

if (typeof window !== "undefined") {
  window.addEventListener("beforeunload", cleanupAllSockets);
  window.addEventListener("pagehide", cleanupAllSockets);
}
